import React from "react";
import TextInfo from "@/bit/components/components.text";
import FaqsList from "./faqs-list";

const CmsFaqs = (props) => {
  const { cmsHandler, blockName, alias, CmsAddElement, CmsEditableGroupIcons } =
    props;
  const titleProps = props["cms-atom-text-1"];
  const faqsList = props["cms-ml-single-faq-list"];

  return (
    <section
      id={blockName || ""}
      className={`FaqsCompo container `}
      data-cy="Section Faqs"
    >
      {titleProps && (
        <TextInfo
          className="faqs--title"
          {...titleProps}
          kind="h"
          level="2"
          cyData="Faqs Title"
          cmsHandler={cmsHandler}
        />
      )}
      <FaqsList
        faqsList={faqsList}
        blockName={blockName}
        alias={alias}
        cmsHandler={cmsHandler}
        CmsAddElement={CmsAddElement}
        CmsEditableGroupIcons={CmsEditableGroupIcons}
      />
      <style jsx>{`.FaqsCompo {
  margin-top: 1.5rem;
  background-color: white;
  padding-bottom: 2rem;
  :global(.faqs--title) {
    margin-bottom: 1rem;
  }
  :global(.faq-item__content--opened > span, p) {
    line-height: 1.5;
  }

  @media screen and (min-width: 1024px) {
    :global(.faqs--title) {
      width: 66.6%;
    }
    :global(.faqs) {
      width: 66.6%;
    }
  }
}
`}</style>
    </section>
  );
};

export default CmsFaqs;
